import React, { createContext, useState, useContext } from 'react'

const initialContext = {
  lastBreadLabel: null,
  setLastBreadLabel() {},
  component: null,
  setComponent() {},
}

export const BreadCrumbContext = createContext(initialContext)

export function useBreadCrumbContext() {
  return useContext(BreadCrumbContext)
}

const BreadCrumbProvider = ({ children }) => {
  const [lastBreadLabel, setLastBreadLabel] = useState(undefined)
  const [component, setComponent] = useState(null)

  return (
    <BreadCrumbContext.Provider
      value={{
        lastBreadLabel,
        setLastBreadLabel,
        component,
        setComponent,
      }}>
      {children}
    </BreadCrumbContext.Provider>
  )
}

export default BreadCrumbProvider
